module.exports = __webpack_public_path__ + "img/unicampo.7aee5771.jpg";